import React from 'react';
import SignUpLayout from 'components/auth/components/SignUpLayout';
import boatsetterPaths, { boatsetterFlags } from 'utils/boatsetterPaths';
import AuthSteps from 'components/auth/components/AuthSteps';
import withFeatureFlagRouting from 'utils/withFeatureFlagRouting';
import { initFirebase } from 'stacks/messaging/Firebase';

initFirebase();

// @TODO remove loading guard after legacy login is removed
export const getServerSideProps = withFeatureFlagRouting({
  flagName: boatsetterFlags.clerkSignup,
  destination: boatsetterPaths.logIn,
  redirectWhen: 'disabled',
});

const Auth = () => (
  <SignUpLayout>
    <AuthSteps />
  </SignUpLayout>
);

export default Auth;
